exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container{\n    width: min(100%, 800px);\n    margin: auto;\n    padding: 1px;\n}\n.form-box {\n    width: 500px;\n    margin: 50px auto;\n}\n.protocol-box {\nimg {\n        display: block;\n        max-width: 100%;\n        margin: auto;\n}\n.btns {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 50px;\n}\n}\n.box {\n    margin-top: -20px;\n    border: 1px solid #ccc;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14266934","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/signContract.vue
// module id = 1092
// module chunks = 0